import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NgbActiveModal, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-delete-wordings",
  templateUrl: "./delete-wordings.component.html",
  styleUrls: ["./delete-wordings.component.scss"],
})
export class DeleteWordingsComponent {
  @Input() name;
  @Input() modelRemove;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() undoModelCode : boolean = false;
  @Input() isMinimumTestingStd: boolean = false;

  ngbModalOptions: NgbModalOptions = {
    windowClass: 'custom-modal'
  };


  constructor(public activeModel: NgbActiveModal, private model: NgbModal) { }

  openModal() {
    this.model.open(DeleteWordingsComponent, this.ngbModalOptions);
  }
  
  onCancel() {
    this.model.dismissAll();
  }
  onDelete() {
    this.passEntry.emit(this.modelRemove);

  }
}
